import { protectedAxiosInstance } from "./axiosManagement";

export const getAbandonedCarts = async (params) => {
  try {
    const response = await protectedAxiosInstance.get("/admin/cart", {
      params: {
        page: params.page,
        length: params.length,
        search: params.search,
        sort_by: params.sort_by,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching abandoned carts:", error);
    throw error;
  }
};

export const getAbandonedCartDetailsItems = (id) => {
  return protectedAxiosInstance
    .get(`/admin/cart/${id}/item`)
    .then((response) => response?.data)
    .catch((error) => {
      throw error;
    });
};

export const getSingleCartDetails = (id) => {
  return protectedAxiosInstance
    .get(`/admin/cart/${id}`)
    .then((response) => response?.data)
    .catch((error) => {
      throw error;
    });
};

export const getShareableToken = (cartId) => {
  return protectedAxiosInstance
    .post(`/admin/cart/${cartId}/generate-shareable-token`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getSingleProjectDetails = (id) => {
  return protectedAxiosInstance
    .get(`/admin/cart/${id}/project-info`)
    .then((response) => response?.data)
    .catch((error) => {
      throw error;
    });
};